import { createTableSlice } from 'features/dashboard/table/createTableSlice'
import { DashboardTypes } from 'features/Codes'
import { serializeError } from 'utils'
import api from 'api/axios/foka'
import { filterMetricColumns } from 'features/dashboard/utils/dashboardUtils'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchCreativeSummary = createAsyncThunk(
  'dashboard/fetchCreativeSummary',
  async ({ from, to, columns, campaignIds, adGroupIds, filters }) => {
    const summary = await api.dashboard
      .getCreativeTableReportTotal({
        from,
        to,
        columns,
        campaignIds,
        adGroupIds,
        filters,
      })
      .then(res => res?.data?.reportResponse?.data[0] || {})
      .catch(() => ({}))
    return { summary }
  }
)

export const fetchCreativeTable = createAsyncThunk(
  'dashboard/fetchCreativeTable',
  async (noArgs, { getState, dispatch, rejectWithValue }) => {
    let error
    const {
      common: { isHeavyUser, from, to },
      filter: { filters },
      table: {
        config: {
          columns: { [DashboardTypes.CREATIVE]: columns },
        },
        campaignTable: { selectedIds: campaignIds },
        adGroupTable: { selectedIds: adGroupIds },
        creativeTable: { page, sort },
      },
    } = getState().dashboard
    if (isHeavyUser && !(campaignIds.length === 1 || adGroupIds.length > 0)) {
      return {
        content: [],
        totalElements: 0,
      }
    }
    const metricColumns = filterMetricColumns(columns)
    if (metricColumns.length > 0) {
      dispatch(
        fetchCreativeSummary({
          from,
          to,
          columns: filterMetricColumns(columns),
          campaignIds,
          adGroupIds,
          filters,
        })
      )
    }
    const { content, totalElements } = await api.dashboard
      .getCreativeTable({
        from,
        to,
        page,
        sort,
        campaignIds,
        adGroupIds,
        filters,
      })
      .then(res => res?.data?.result)
      .catch(err => {
        error = serializeError(err)
        return {
          content: [],
          totalElements: 0,
        }
      })
    if (error) {
      return rejectWithValue(error)
    } else {
      let metricError
      const metrics =
        totalElements === 0 || metricColumns.length === 0
          ? {}
          : await api.dashboard
              .getCreativeTableReport({
                from,
                to,
                columns: metricColumns,
                ids: content.map(({ creativeLinkId }) => creativeLinkId),
              })
              .then(res => res?.data?.metrics)
              .catch(() => {
                metricError = '지표 데이터를 불러오지 못했습니다.'
                return {}
              })
      return {
        totalElements,
        content: content.map(item => ({
          ...item,
          ...metrics[item.creativeLinkId],
        })),
        error: metricError,
      }
    }
  }
)
const creativeTableSlice = createTableSlice({
  type: DashboardTypes.CREATIVE,
  fetcher: fetchCreativeTable,
  summaryFetcher: fetchCreativeSummary,
})
const { actions, reducer } = creativeTableSlice
export const creativeTableActions = actions
export const {
  reset,
  toggleSelectedId,
  setSelectedIds,
  setPage,
  setSort,
  clearError,
  setStatus,
} = actions
export default reducer
